"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const convertBallsTotalToOvers_1 = __importDefault(require("./convertBallsTotalToOvers"));
const convertOversToBallsTotal_1 = __importDefault(require("./convertOversToBallsTotal"));
const getOversRemaining = (props) => {
    const bpo = props.ballsPerOver || undefined;
    const tB = (0, convertOversToBallsTotal_1.default)({
        overs: props.oversTarget || props.oversPerInnings,
        ballsPerOver: bpo,
    });
    const oB = (0, convertOversToBallsTotal_1.default)({
        overs: props.oversBowled,
        ballsPerOver: bpo,
    });
    return (0, convertBallsTotalToOvers_1.default)({
        balls: tB - oB,
        ballsPerOver: bpo,
    });
};
exports.default = getOversRemaining;
//# sourceMappingURL=getOversRemaining.js.map